import { useState } from "react";
import { PageHead, Reveal } from "@/components/Motion";
import { Lightbox } from "@/components/Lightbox";
import { Loading, useApi } from "@/components/Common";
import { media, ERAS } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

export default function Gallery() {
  const { session } = useSite() || {};
  const { data, loading } = useApi("/public/gallery", [session?.active]);
  const [era, setEra] = useState("all");
  const [i, setI] = useState(null);
  const all = Array.isArray(data?.items) ? data.items : [];
  const items = era === "all" ? all : all.filter((x) => x.era === era);
  return (
    <div data-testid="gallery-page">
      <PageHead eyebrow="Gallery" title="The album, opened slowly" line="Moments from the family archive, one frame at a time." />
      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-28">
        <div className="flex flex-wrap gap-2 mb-10">
          {[["all", "All eras"], ...ERAS.map((e) => [e.id, e.label])].map(([k, l]) => (
            <button key={k} onClick={() => setEra(k)} className={`btn-sm rounded-full border transition-colors ${era === k ? "bg-[#C9A24B] text-[#0B1D14] border-[#C9A24B]" : "border-[#C9A24B]/40 text-[#F6EFE0]/85 hover:border-[#C9A24B]"}`} data-testid={`gallery-filter-${k}`}>{l}</button>
          ))}
        </div>
        {loading ? <Loading /> : (
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
            {items.map((ph, k) => (
              <Reveal key={ph.id} delay={(k % 3) * 0.06} className="mb-5 break-inside-avoid">
                <button className="group block w-full text-left photo-frame" onClick={() => setI(k)} data-testid={`gallery-item-${k}`}>
                  <img src={media(ph.url)} alt={ph.caption} loading="lazy" className="w-full h-auto transition-[filter,transform] duration-1000 group-hover:scale-[1.03]" style={{ filter: ph.era === "silent" ? "grayscale(1)" : ph.era === "sepia" ? "sepia(.7)" : "none" }} />
                  <span className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-black/80 to-transparent text-xs text-[#F6EFE0] opacity-0 group-hover:opacity-100 transition-opacity">{ph.caption}</span>
                </button>
              </Reveal>
            ))}
          </div>
        )}
      </section>
      <Lightbox items={items} index={i} onClose={() => setI(null)} onIndex={setI} />
    </div>
  );
}
